import isMobile from 'ismobilejs'

export const deviceDetector = {
  isMobile(): boolean {
    return this._detectDevice().phone
  },
  isTablet(): boolean {
    return this._detectDevice().tablet
  },
  isDesktop(): boolean {
    return !this._detectDevice().any
  },
  _detectDevice() {
    return isMobile()
  },
}
